var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.816 9.636v20.951a3.923 3.923 0 01-3.922 3.922H8.84a3.923 3.923 0 01-3.923-3.922V5.923A3.923 3.923 0 018.839 2h14.125l6.852 7.636z",
    fill: "#FFE4BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.595 27.67h19.17a2.32 2.32 0 012.32 2.32v5.69a2.32 2.32 0 01-2.32 2.32h-19.17a2.32 2.32 0 01-2.32-2.32v-5.69a2.32 2.32 0 012.32-2.32zM29.816 9.636h-2.93a3.923 3.923 0 01-3.922-3.922V2l6.852 7.636z",
    fill: "#FF9908"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.779 35.357a.435.435 0 11.87 0 .435.435 0 01-.87 0zM18.995 30.197v5.517h-.816v-2.377h-2.75v2.377h-.817v-5.517h.816v2.37h2.751v-2.37h.816zM23.02 30.966h-1.329v4.748h-.808v-4.748h-1.329v-.769h3.466v.77zM29.43 30.197v5.517h-.815v-4.048l-1.85 2.976h-.35l-1.85-2.976v4.048h-.815v-5.517h.816l2.02 3.233 2.029-3.233h.816zM33.479 34.945v.77h-3.062v-5.518h.808v4.748h2.254z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.719 16.435l-3.301 1.33 3.3 1.318v.92l-4.413-1.778v-.931l4.414-1.766v.907zM16.813 21.138h-.708l2.51-6.699h.707l-2.51 6.699zM24.943 17.294v.93l-4.426 1.778v-.919l3.301-1.318-3.3-1.33v-.907l4.425 1.766z",
    fill: "#FF9908"
  })));
}
export default SvgHtmlLinkIcon;